export {withCssModule, hashedClasses} from './with-css-module';
